import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-01d9cd79")

_pushScopeId("data-v-01d9cd79")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" アカウント設定 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_side_menu = _resolveComponent("side-menu")
  const _component_account_setting_name = _resolveComponent("account-setting-name")
  const _component_account_setting_password = _resolveComponent("account-setting-password")
  const _component_vue_two_column_content = _resolveComponent("vue-two-column-content")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_vue_two_column_content, null, {
        left: _withId(() => [
          _createVNode(_component_side_menu, {
            menus: _ctx.tabs,
            onMenu: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTab($event)))
          }, null, 8, ["menus"])
        ]),
        right: _withId(() => [
          (_ctx.selectedIndex===0)
            ? (_openBlock(), _createBlock(_component_account_setting_name, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.selectedIndex===1)
            ? (_openBlock(), _createBlock(_component_account_setting_password, { key: 1 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})